import React from 'react';
import { analytics, urlCatalog, Track } from 'angieslist-app-platform';
import { formatPhoneNumber, formatPhoneUrl } from 'angieslist-app-platform/lib/common/utils/stringUtils';
import { Button, Col, Grid, Row } from 'angieslist-react-components';
import { compose, pure } from 'recompose';
import { isUndefined } from 'lodash';
import { trackEvent } from '../../../../../app/browser/analyticsHelpers';
import { GenericCard } from './Card/GenericCard';
import CardModal from '../Dashboard/Card/CardModal';
import CircularIcon from '../Dashboard/CircularIcon';

import './ClientSuccessManagerCard.scss';

type Props = {
  name: string,
  phone: string,
  email: string,
  isLoading: boolean,
  serviceProviderId: number,
};

type State = {
  showModal: boolean,
};

const styles = {
  modalBody: {
    display: 'flex',
    justifyContent: 'center',
  },
};

class ClientSuccessManagerCardComponent extends React.Component {
  constructor(props: Props) {
    super(props);
    this.state = {
      showModal: false,
    };
  }

  state: State;
  props: Props;

  handleToggle = () => this.setState({ showModal: !this.state.showModal })

  render() {
    const {
      name, phone, email, serviceProviderId, isLoading,
    } = this.props;

    const phoneNumber = phone === 'no-phone' || isUndefined(phone) ?
      urlCatalog.global.businessCenterPhoneText() : phone;
    const finalEmail = isUndefined(email) ? urlCatalog.global.businessCenterEmail() : email;

    return (
      <span>
        <Track>
          <div id="Client-Success-Manager-Card--Container" onKeyDown={this.handleToggle} tabIndex={0} onClick={this.handleToggle} role="button">
            <GenericCard>
              <Grid style={{ width: '100%' }}>
                <Row style={{ width: '100%' }}>
                  <Col xs={2} sm={1} md={1}>
                    <i
                      className={`icon icon-2x ${isLoading ? 'icon-load icon-spin' : 'icon-headset'}`}
                      style={{ marginLeft: '-0.25em' }}
                    />
                  </Col>
                  <Col xs={7} smPush={1} sm={10} md={6} lg={7} style={{ fontSize: '0.9em', paddingBottom: '1em' }}>
                    <div><strong>{name || 'Angi Business Center'}</strong></div>
                    <div>Client Success Manager</div>
                  </Col>
                  <Col xs={12} mdPush={1} md={1} style={{ marginLeft: '-5px' }}>
                    <Button
                      id="dashboard--client-success-manager-modal--contact-button"
                      bsSize="xsmall"
                      bsStyle="default-office"
                    >
                      Contact
                    </Button>
                  </Col>
                  <Col xs={3} smPush={2} sm={10} md={2} lg={1}>
                    <CardModal
                      showModal={this.state.showModal}
                      handleClose={this.handleToggle}
                      iconClassName="icon-headset"
                      headerText={name || 'Angi Business Center'}
                      subHeaderText="Client Success Manager"
                      modalBody={
                        <div style={styles.modalBody}>
                          <div>
                            <p>
                              <Track>
                                <Button
                                  bsStyle="link"
                                  id="dashboard--client-success-manager-modal--phone-button"
                                  bsSize="small"
                                  href={`tel:${formatPhoneUrl(phoneNumber)}`}
                                  data-track-spid={serviceProviderId}
                                >
                                  <span style={{ marginRight: '0.5em' }}>
                                    <CircularIcon iconClassName="icon-phone" />
                                  </span>
                                  <strong>{formatPhoneNumber(phoneNumber)}</strong>
                                </Button>
                              </Track>
                            </p>
                            <p>
                              <Track>
                                <Button
                                  bsStyle="link"
                                  id="dashboard--client-success-manager-modal--email-button"
                                  bsSize="small"
                                  href={`mailto:${finalEmail}`}
                                  data-track-spid={serviceProviderId}
                                >
                                  <span style={{ marginRight: '0.5em' }}>
                                    <CircularIcon iconClassName="icon-messages" />
                                  </span>
                                  <strong>{finalEmail}</strong>
                                </Button>
                              </Track>
                            </p>
                          </div>
                        </div>
                    }
                    />
                  </Col>
                </Row>
              </Grid>
            </GenericCard>
          </div>
        </Track>
      </span>
    );
  }
}

const otherProps = {
  serviceProviderId: '<<attributes.data-track-spid.value>>',
};

const clientSuccessManagerCardAnalytics = {
  elements: {
    'dashboard--client-success-manager-contact-button-wrapper-*': trackEvent(
      'Modal Fired', 'SP : Home', 'Rep Contact Info',
      otherProps,
    ),
    'dashboard--client-success-manager-modal--phone-button': trackEvent(
      'Phone Number Clicked', 'Rep Contact Info', 'Call Rep',
      otherProps,
    ),
    'dashboard--client-success-manager-modal--email-button': trackEvent(
      'Email Clicked', 'Rep Contact Info', 'Email Rep',
      otherProps,
    ),
    'Client-Success-Manager-Card--Container': trackEvent('Modal Fired', 'SP : Home', 'CSM Contact'),
  },
};

export { ClientSuccessManagerCardComponent };

export default (compose(
  analytics({
    ruleset: clientSuccessManagerCardAnalytics,
  }),
  pure,
)(ClientSuccessManagerCardComponent): any);



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/DashboardV2/ClientSuccessManagerCard.js